import { OptionBadgeGroup } from '../components/OptionBadgeGroup';
import { USAGE_OPTIONS } from '../constants';
import type { StepProps } from '../types';
import { useTranslation } from 'react-i18next';

export function StepUsage({ answers, setAnswer }: StepProps) {
  const { t } = useTranslation('onboarding');
  const usageOptions = USAGE_OPTIONS.map((option) => ({
    ...option,
    label: t(`usage.${option.id}`),
  }));
  return (
    <OptionBadgeGroup
      options={usageOptions}
      selected={answers.usage}
      onChange={(val) => setAnswer('usage', val)}
    />
  );
}
